<app-page-title [title]="'order Incompleted'"></app-page-title>
<div class="row pl-4">
    <div class="col-md-12">
        <p>
            <strong>
                If your order status is incomplete, here are a few things you can try:
            </strong>
        </p>
        <ul>
            <li>
                Make sure that there are sufficient funds in your account.
            </li>
            <li>
                Check that your card has not expired.
            </li>
            <li>
                Contact your credit card company to see why your transaction to Paragon Testing Enterprises located in Vancouver, Canada is being declined.
            </li>
            <li>
                If you are trying to use a VISA ® Debit card, please be aware that we do not accept this as a payment. See below for alternative methods of payment.
            </li>
            <li>
                Try using a different credit card, paying through PayPal, or using a prepaid credit cards such as a <a
                    href="http://www.mastercard.ca/prepaid-card.html"
                    target="_blank"
                >Mastercard® Prepaid Card</a> or <a
                    href="http://www.visa.ca/en/personal/prepaidcards/giftcards.jsp"
                    target="_blank"
                > Visa® Gift Card</a>.
            </li>
            <li>
                Payment must be made with one card only.
            </li>
            <li *ngIf="brandId === BrandEnum.CELPIP">
                If your order still cannot be processed successfully, feel free to contact us by email at <a
                    href="mailto:info@celpip.ca"
                    target="_top"
                >info@celpip.ca</a> or call 1-800-958-5186 (toll free within North America), Monday to Sunday, 5:30 a.m. to 5:00 p.m. (Pacific Standard Time).
            </li>
            <li *ngIf="brandId === BrandEnum.CAEL">
                If your order still cannot be processed successfully, feel free to contact us by email at <a
                    href="mailto:info@cael.ca"
                    target="_top"
                >info@cael.ca</a> or call 1-855-520-2235 (toll free within North America), Monday to Sunday, 5:30 a.m. to 5:00 p.m. (Pacific Standard Time).
            </li>
        </ul>
        <br />
        <a
            [routerLink]="[checkoutUrl]"
            class="btn btn-primary pull-right"
        >Checkout</a>
    </div>
</div>
